module.exports = __webpack_public_path__ + "static/media/resource-header.81f6dcf5.png";